import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

const NewHero = () => {
  const heroRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: heroRef,
    offset: ['start start', 'end start'],
  });

  const decorOpacity = useTransform(scrollYProgress, [0, 0.6], [1, 0]);

  return (
    <section
      ref={heroRef}
      className="relative w-full min-h-screen overflow-hidden flex items-center pt-24 md:pt-28 pb-20 md:pb-24"
      id="hero"
    >
      <div className="relative z-10 container-edge w-full">
        <div className="flex flex-col items-start gap-5 md:gap-8 max-w-[1200px]">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="eyebrow">Source-level piracy defence</span>
          </motion.div>

          <div className="relative w-full">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1] }}
              className="font-display font-bold leading-[0.82] tracking-tightest text-white"
              style={{ fontSize: 'clamp(5rem, min(19vw, 34vh), 17rem)' }}
            >
              <span className="block">4</span>
              <span className="block text-teal italic font-semibold tracking-tight"
                    style={{ fontSize: 'clamp(1.75rem, min(5vw, 8vh), 4.75rem)', lineHeight: 0.95 }}>
                seconds.
              </span>
            </motion.h1>
          </div>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.35, duration: 0.7 }}
            className="max-w-2xl text-xl md:text-2xl lg:text-3xl text-white font-normal leading-[1.3]"
          >
            We find every pirate stream.{' '}
            <span className="text-teal font-medium">And kill it at source.</span>
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.55 }}
          >
            <a href="#cta" className="btn-teal">
              Talk to us
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M13 5l7 7-7 7" />
              </svg>
            </a>
          </motion.div>
        </div>
      </div>

      <motion.div
        style={{ opacity: decorOpacity }}
        className="absolute bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 z-10"
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.1 }}
          className="flex flex-col items-center gap-2 md:gap-3"
        >
          <span className="font-mono text-[0.65rem] uppercase tracking-[0.4em] text-white/45">
            Scroll
          </span>
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 1.8, repeat: Infinity }}
            className="h-10 md:h-12 w-px bg-gradient-to-b from-teal to-transparent"
          />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default NewHero;

